import styled from 'styled-components';

import {
  typography,
  size,
  mediaQueries,
  InfoBlock as InfoBlockBase,
} from '@everlywell/leaves';

const SectionHeadline = styled.h2`
  ${typography.h1Text}
  margin-bottom: ${size.md}px;
  text-align: left;
  ${mediaQueries.forTabletHorizontalUp} {
    text-align: center;
  }
`;

const SectionSubheadline = styled.p`
  ${typography.bodyText}
  margin-bottom: ${size.xl1}px;
  text-align: left;
  ${mediaQueries.forTabletHorizontalUp} {
    text-align: center;
    margin-bottom: ${size.xl4}px;
  }
`;

const InfoBlockContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  margin-bottom: 2rem;
  ${mediaQueries.forTabletHorizontalUp} {
    margin-bottom: 6rem;
    flex-direction: row;
  }
`;

const InfoBlockWrapper = styled.div`
  ${mediaQueries.forTabletHorizontalUp} {
    flex: 0 0 33%;
    &:not(:last-child) {
      padding-right: ${size.lg}px;
    }
  }
`;

const InfoBlock = styled(InfoBlockBase).attrs((props) => ({
  imageAlt: props.imageAlt,
}))`
  margin-bottom: ${size.xl1}px;

  > div > div {
    background-color: transparent;
  }
`;

export {
  SectionHeadline,
  SectionSubheadline,
  InfoBlockContainer,
  InfoBlockWrapper,
  InfoBlock,
};
